
import type { Redirection } from '@empathybroker/tsclient-play/dist/models/redirection'
import type { CrudListData } from '../../mixins/crud-list.mixin'
import type { DataTableColumn, DataTableOption } from '../../models'
import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum'
import { defineComponent } from 'vue'
import CrudList from '../../components/crud/crud-list.component.vue'
import DataTable from '../../components/crud/data-table.component.vue'
import { UiTooltip } from '../../components/keen-ui'
import { AlignEnum, FeatureIdEnum } from '../../enums'
import { CrudListMixin } from '../../mixins/crud-list.mixin'
import { ROUTER_CONSTS } from '../../router/router.consts'

export default defineComponent({
  name: 'RedirectionsList',
  components: {
    CrudList,
    DataTable,
    UiTooltip,
  },
  mixins: [CrudListMixin],
  data(): Partial<CrudListData> {
    return {
      dataType: ActionTypeEnum.REDIRECTION,
      routes: {
        create: ROUTER_CONSTS.routes[FeatureIdEnum.REDIRECTION].create,
        update: ROUTER_CONSTS.routes[FeatureIdEnum.REDIRECTION].update,
      },
      messages: this.$epb.messages.tools.redirections,
    }
  },
  computed: {
    tableColumns(): Array<DataTableColumn> {
      const fieldMessages = this.messages.fields
      return [
        ...this.filtersColumns,
        {
          id: 'keywords',
          text: fieldMessages.keywords.label,
          unwrapText: true,
          copyToClipboard: true,
        },
        {
          id: 'url',
          text: fieldMessages.url.label,
          width: '200%',
        },
        {
          id: 'schedule',
          text: fieldMessages.schedule.label,
        },
        {
          id: 'meta.updateDate',
          text: fieldMessages.updateDate.label,
          sortable: true,
        },
        {
          id: 'enabled',
          text: fieldMessages.enabled.label,
          sortable: true,
        },
        {
          id: 'options',
          width: '44px',
          align: AlignEnum.CENTER,
        },
      ]
    },
  },
  methods: {
    getKeywordsText(redirection: Redirection) {
      return redirection.keywords.join(', ')
    },
    onOptionsClick(option: DataTableOption, dataItem) {
      this.onOptionClick(option, dataItem, this.$refs.crudListRef)
    },
  },
})
